import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from "@angular/core";
import { UnitaDocumentariaVO } from "@app/shared/vo/unita-documentariaVO";
import { CollegamentoUnitaDocumentariaService } from "@app/shared/services/collegamento-unita-documentaria.service";
import { WrapperCollegamentoUnitaDocumentariaVO } from "@app/shared/vo/wrapper-collegamento-unita-documentariaVO";
import { ProfiliHelper } from "@app/shared/helper/profili.helper";
import { VisibilitaFascicoloVO } from "@app/shared/vo/visibilita-fascicoloVO";
import { DocumentoService } from "@app/shared/services/documento.service";
import { OrdinamentoVO } from "@app/shared/vo/ordinamentoVO";
import { PaginazioneVO } from "@app/shared/vo/paginazioneVO";
import { AttivitaUnitaDocumentariaVO } from "@app/shared/vo/attivita-unita-documentariaVO";
import { UtenteVO } from "@app/shared/vo/utenteVO";
import { ListaVisibilitaVO } from "@app/shared/vo/lista-visibilita/lista-visibilitaVO";
import { GruppiVisibilitaService } from "@app/shared/services/gruppi-visibilita.service";

@Component({
  selector: "app-elementi-ud",
  templateUrl: "./elementi-ud.component.html",
})
export class ElementiUdComponent implements OnInit, OnChanges {
  @Input()
  unitaDocumentaria: UnitaDocumentariaVO;

  @Input()
  utente: UtenteVO;

  @Input()
  cambiamentiCollegamenti: boolean;

  @Input()
  nascondiStorico: boolean;

  @Output()
  emettiDettaglioRow: EventEmitter<
    WrapperCollegamentoUnitaDocumentariaVO
  > = new EventEmitter();

  documentiCollegati: WrapperCollegamentoUnitaDocumentariaVO[];
  showResults: boolean = false;
  @Input()
  showResultsStorico: boolean = false;
  ordinamento: OrdinamentoVO;
  paginazione: PaginazioneVO;
  storicoModifiche: AttivitaUnitaDocumentariaVO[];
  loadingIndicator: boolean;
  constructor(
    private collegamentoUdService: CollegamentoUnitaDocumentariaService,
    private profiliHelper: ProfiliHelper,
    private documentoService: DocumentoService
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes != null &&
      ((changes.unitaDocumentaria != null &&
        changes.unitaDocumentaria.currentValue != null &&
        changes.unitaDocumentaria.previousValue) ||
        changes.cambiamentiCollegamenti != null)
    ) {
      console.log("[ElementiUdComponent][onChanges] simpleChanges: ", changes);
      this.ricercaDocCollegati();
    }

    if (changes.unitaDocumentaria != null) {
      this.ordinamento = new OrdinamentoVO();
      this.paginazione = new PaginazioneVO();
      this.ordinamento.elemento = "dataOperazione";
      this.ordinamento.direzione = 1;
      this.paginazione.size = 3;
      this.paginazione.pageNumber = 0;
      this.getStoricoModifiche();
    }
  }

  public setPagStorico(pageInfo) {
    this.loadingIndicator = true;
    this.paginazione.pageNumber = pageInfo;
    this.getStoricoModifiche();
  }

  getStoricoModifiche() {
    console.log("getStoricoModifiche", this.ordinamento.direzione);
    this.loadingIndicator = true;
    this.documentoService
      .storicoModifiche(
        this.unitaDocumentaria.id,
        this.paginazione,
        this.ordinamento
      )
      .subscribe((res) => {
        console.log("recuperato storico ", res);
        this.storicoModifiche = res.resultList;
        this.paginazione = res.paginazione;
        this.loadingIndicator = false;
      });
  }

  public sortOperazioni(event: any) {
    this.ordinamento = new OrdinamentoVO();
    console.log("sortInfo received: >> ", event);
    console.log(event.prop);
    this.ordinamento.elemento = event.prop;
    console.log(this.ordinamento.elemento);
    if (event.dir === "asc") {
      this.ordinamento.direzione = 0;
    } else {
      this.ordinamento.direzione = 1;
    }
    this.getStoricoModifiche();
  }

  async ricercaDocCollegati() {
    this.documentiCollegati = await this.collegamentoUdService
      .getCollegamenti(this.unitaDocumentaria.id, true)
      .toPromise();
  }

  public controlliPermessiVisibilita(
    listaVisibilita: VisibilitaFascicoloVO[]
  ): boolean {
    return this.profiliHelper.haVisibilitaInListaVisibilita(listaVisibilita);
  }

  async vaiAlDettaglio(row: WrapperCollegamentoUnitaDocumentariaVO) {
    this.emettiDettaglioRow.emit(row);
  }
}
